<ac-form *ngIf="dialogConfig.ready"
         [formModel]="service"
         [auxiliaryModel]="additionalSettings"
         [validateAuxiliaryForm]="validateAuxiliaryForm"
         [formSchema]="schema"
         [isEdit]="isEdit"
         formModelName="service">

    <div id="service-details-dialog-content">
        <div class="flexRowParentEqualChildren">
            <ac-input-container label="Name" [displayAsInfo]="isEdit" formFieldName="service.serviceName">
                <ac-textfield [(acModel)]="service.serviceName"
                              [ngDisabled]="isEdit" textFieldId="service-name">
                </ac-textfield>
            </ac-input-container>


            <ac-input-container label="Service Source" [displayAsInfo]="true" formFieldName="additionalSettings.serviceType">
                <ac-textfield [(acModel)]="additionalSettings.serviceType"
                              [ngDisabled]="true"
                              textFieldId="service-serviceType">
                </ac-textfield>
            </ac-input-container>
        </div>

        <ac-input-container label="Customer" formFieldName="service.lcCustomerId" *ngIf="lcCustomers" [readOnly]="true">
            <ac-single-select [(acModel)]="service.lcCustomerId"
                              [ngDisabled]="true"
                              bindValue="id"
                              bindLabel="name"
                              [items]="lcCustomers">
            </ac-single-select>
        </ac-input-container>

        <ac-input-container label="Service Provider" *ngIf="tenants" formFieldName="additionalSettings.tenantId">
            <ac-single-select [(acModel)]="additionalSettings.tenantId"
                              (acModelChange)="tenantChange($event)"
                              [ngDisabled]="isEdit"
                              bindValue="id"
                              bindLabel="name"
                              [items]="tenants">
            </ac-single-select>
        </ac-input-container>

        <ac-input-container label="Description" formFieldName="service.description">
            <ac-textfield [(acModel)]="service.description"
                         textFieldId="service-description">
            </ac-textfield>
        </ac-input-container>

        <ac-input-container label="License Type" formFieldName="service.licenseType" *ngIf="service.serviceSource === 'HYBRID_ENTITIES'">
            <ac-single-select [(acModel)]="service.hybridParams.licenseType"
                              [items]="licenseTypeList">
            </ac-single-select>
        </ac-input-container>
    </div>
</ac-form>
